module.exports = __webpack_public_path__ + "img/performance-school-icon5.2e688e01.png";